import { connect } from 'react-redux';
import { getToBePaidOutIds, hasNextSlip, hasToBePaidOutBets } from '../selectors';
import ToBePaidOut from './ToBePaidOut';

const mapStateToProps = state => ({
  bets: getToBePaidOutIds(state),
  hasBets: hasToBePaidOutBets(state),
  showLoadNextSlip: hasNextSlip(state)
});

export default connect(mapStateToProps)(ToBePaidOut);
